export default {
  'contact.title': 'Entrer en contact',
  'contact.subtitle': 'Prêt à transformer votre entreprise avec nos solutions technologiques ? Contactez-nous aujourd\'hui pour discuter de vos besoins et découvrir comment nous pouvons vous aider à atteindre vos objectifs.',
  
  'contact.info.title': 'Informations de contact',
  'contact.info.description': 'Nous sommes là pour vous aider et répondre à toute question que vous pourriez avoir. Nous avons hâte d\'avoir de vos nouvelles.',
  
  'contact.form.name': 'Nom complet',
  'contact.form.email': 'Adresse e-mail',
  'contact.form.phone': 'Numéro de téléphone',
  'contact.form.company': 'Entreprise',
  'contact.form.subject': 'Sujet',
  'contact.form.message': 'Message',
  'contact.form.send': 'Envoyer le message',
  'contact.form.sending': 'Envoi en cours...',
  
  'contact.form.nameLabel': 'Nom complet',
  'contact.form.emailLabel': 'Adresse e-mail',
  'contact.form.phoneLabel': 'Numéro de téléphone',
  'contact.form.companyLabel': 'Entreprise',
  'contact.form.serviceLabel': 'Intérêt pour le service',
  'contact.form.messageLabel': 'Message',
  'contact.form.selectService': 'Sélectionner un service',
  'contact.form.messagePlaceholder': 'Parlez-nous de votre projet ou de votre intérêt d\'investissement...',
  
  'contact.form.services.digitalPayments': 'Solutions de paiement numérique',
  'contact.form.services.bankingSoftware': 'Logiciels bancaires',
  'contact.form.services.customDevelopment': 'Développement de logiciels personnalisés',
  'contact.form.services.investment': 'Investissement technologique stratégique',
  'contact.form.services.cyclosSupport': 'Support Cyclos',
  'contact.form.services.consultation': 'Consultation générale',
  'contact.success': 'Merci ! Votre message a été envoyé avec succès.',
  'contact.error': 'Désolé, une erreur s\'est produite lors de l\'envoi de votre message. Veuillez réessayer.',
  
  'contact.address.title': 'Adresse du bureau',
  'contact.phone.title': 'Numéro de téléphone',
  'contact.email.title': 'Adresse e-mail',
  
  'contact.businessHours.title': 'Heures d\'ouverture',
  'contact.businessHours.weekdays': 'Lundi - Vendredi',
  'contact.businessHours.weekdaysHours': '9h00 - 18h00',
  'contact.businessHours.saturday': 'Samedi',
  'contact.businessHours.saturdayHours': '10h00 - 16h00',
  'contact.businessHours.sunday': 'Dimanche',
  'contact.businessHours.closed': 'Fermé',
};
